import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { faImage, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'fc-user-reviews-image-dialog',
  templateUrl: './user-reviews-image-dialog.component.html',
  styleUrls: ['./user-reviews-image-dialog.component.css'],
})
export class UserReviewsImageDialogComponent implements OnInit {
  faSpinner = faSpinner;
  faTimes = faTimes;
  faImage = faImage;

  reviewForm: FormGroup;
  isSubmitted: boolean = false;
  loading: boolean = false;
  errMessage: string = '';

  constructor(private sanitizer: DomSanitizer, private ref: DynamicDialogRef) {
    this.reviewForm = new FormGroup({
      image_file: new FormControl('', Validators.required),
      src_file: new FormControl(''),
    });
  }

  ngOnInit(): void {}

  handleSkinFitFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      let files = event.target.files[0];

      this.reviewForm.get(`image_file`)?.setValue(files);
      const reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = (_e) => {
        let sanitizedImg = this.sanitizer.bypassSecurityTrustUrl(
          reader.result as string
        );
        this.reviewForm.patchValue({
          src_file: sanitizedImg,
        });
      };
    }
  }

  onSubmit() {
    this.isSubmitted = true;
    const formValue = this.reviewForm.value;
    let formData: FormData = new FormData();
    formData.append('image_file', formValue.image_file);
    if (this.reviewForm.valid) {
      this.ref.close(this.reviewForm.value);
    }
  }

  onCloseModal() {
    this.ref.close();
  }
}
